<template>
	<el-drawer title="一番赏奖品" :visible.sync="isDrawer" :with-header="false" size="86%" :before-close="handleClose"
		:modal-append-to-body="false" :wrapperClosable="false" :close-on-press-escape="false">
		<div class="drawer_title pall-30 flex flex-jb flex-n">
			<div class="fs-18 fw-bold">一番赏奖品</div>
			<i class="el-icon-close fs-20" @click="handleClose"></i>
		</div>
		<div class="ml-30">
			<el-button type="text" class="fs-16" @click="addList">
				<i class="el-icon-circle-plus-outline mr-10 fs-18"></i>新增</i>
			</el-button>
		</div>
		<TableHeightFull class="tableDiv pall-30">
			<!-- 表格 -->
			<EleTable ref="tableRef" slot="table" :tableData="tableData" :columns="columns" height="100%" :border="false"
				v-loading="tabLoading" :row-style="{ cursor: 'pointer' }">
				<template v-slot:propImg="e">
					<img :src="e.row.propImg" alt="" class="smallImg" v-if="e.row.propImg" />
				</template>
			</EleTable>
			<!-- 分页 -->
			<!-- <PagingComponent slot="after" :page-info="pageInfo" @getTableData="getTableData" /> -->
		</TableHeightFull>
		<!-- 		<div class="drawer_button pall-30 flex-n flex flex-ac flex-je">
			<el-button type="primary" @click="submitForm">{{goodId?'保存':'提交'}}</el-button>
			<el-button type="primary" plain @click="handleClose">取消</el-button>
		</div> -->
		<!-- 弹框 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" append-to-body top="10vh" width="30%"
			@close="resetForm">
			<el-form :model="raffleRedsProp" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="道具类型" prop="propType" v-if="'propType' in raffleRedsProp"
					:rules="{required: true, message: '请至少选择一个道具卡类型', trigger: 'change'}">
					<el-select v-model="raffleRedsProp.propType" placeholder="请选择">
						<el-option v-for="item,index in propTypes" :key="index" :label="item.key" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="图片" prop="propImg" v-if="'propImg' in raffleRedsProp && raffleRedsProp.propType == 1"
					:rules="{required: true, message: '图片不能为空', trigger: 'blur'}">
					<upload-file upStyle="width: 80px; height: 80px; border-radius: 5px; overflow: hidden;"
						iconName="el-icon-upload" iconSize="26" v-model="raffleRedsProp.propImg"></upload-file>
				</el-form-item>
				<el-form-item label="预售时间" prop="presellDate"
					v-if="'presellDate' in raffleRedsProp && raffleRedsProp.propType == 1">
					<el-date-picker v-model="raffleRedsProp.presellDate" type="date" valueFormat="yyyy-MM-dd" placeholder="选择预售时间"
						@change="handPickerChange">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="道具名称" prop="propName" v-if="'propName' in raffleRedsProp"
					:rules="{required: true, message: '道具名称不能为空', trigger: 'blur'}">
					<el-input type="text" v-model="raffleRedsProp.propName"></el-input>
				</el-form-item>
				<el-form-item label="道具数量" prop="propNum" v-if="'propNum' in raffleRedsProp"
					:rules="{required: true, message: '道具数量不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="raffleRedsProp.propNum"></el-input>
				</el-form-item>
				<el-form-item label="有效天数" prop="validDay" v-if="'validDay' in raffleRedsProp && raffleRedsProp.propType!=1"
					:rules="{required: true, message: '有效天数不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="raffleRedsProp.validDay"></el-input>
				</el-form-item>
				<el-form-item label="抽赏次数" prop="seriesRaffleNum" v-if="'seriesRaffleNum' in raffleRedsProp"
					:rules="{required: true, message: '抽赏次数不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="raffleRedsProp.seriesRaffleNum"></el-input>
				</el-form-item>
				<el-form-item label="优惠券面额" prop="money" v-if="'money' in raffleRedsProp && raffleRedsProp.propType == 4"
					:rules="{required: true, message: '优惠券面额不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="raffleRedsProp.money"></el-input>
				</el-form-item>
				<el-form-item label="优惠券类型" prop="couponsType"
					v-if="'couponsType' in raffleRedsProp && raffleRedsProp.propType == 4"
					:rules="{required: true, message: '请至少选择一个优惠劵类型', trigger: 'change'}">
					<el-select v-model="raffleRedsProp.couponsType" placeholder="请选择">
						<el-option v-for="item in couponsTypes" :key="item.value" :label="item.key" :value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="使用门槛" prop="doorSill" v-if="'doorSill' in raffleRedsProp && raffleRedsProp.propType == 4"
					:rules="{required: true, message: '使用门槛不能为空', trigger: 'blur'}">
					<el-input type="number" v-model="raffleRedsProp.doorSill"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="affirmPopup" :loading="butLoading">确 定</el-button>
			</div>
		</el-dialog>
	</el-drawer>
</template>
<script>
	import indexMixin from "@/utils/indexMixin"
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'rewardBag',
		mixins: [indexMixin],
		components: {
			"EleTable": (resolve) => require(["@/components/public/TSimpleTable"], resolve),
			"TableHeightFull": (resolve) => require(["@/components/public/TableHeightFull"], resolve),
			"PagingComponent": (resolve) => require(["@/components/public/PagingComponent"], resolve),
			"UploadFile": (resolve) => require(["@/components/UploadFile"], resolve),
		},
		computed: {
			...mapState('menu', {
				'propTypes': state => state.dictList ? state.dictList.prop_type : [], //道具类型
				'couponsTypes': state => state.dictList ? state.dictList.coupons_type : [], //优惠劵类型
			})
		},
		data() {
			return {
				isDrawer: false,
				dialogFormVisible: false,
				butLoading: false,
				tabLoading: false,
				goodId: '',
				dialogTitle: '新增',
				columns: [{
					label: '抽赏次数',
					prop: 'seriesRaffleNum',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					columnType: 'custom',
					label: '道具图片',
					prop: 'propImg',
					align: 'left',
					// width: '80'					presellDate:'',
				}, {
					label: '预售时间',
					prop: 'presellDate',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					label: '道具名称',
					prop: 'propName',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					columnType: 'fun',
					label: '道具类型',
					prop: 'propType',
					// width:'100',
					align: 'left',
					'show-overflow-tooltip': true,
					formatData: (e) => {
						let ele = this.propTypes.find(ele => ele.value == e)
						return ele ? ele.key : e
					}
				}, {
					label: '道具数量',
					prop: 'propNum',
					align: 'left',
					// width: '80'
				}, {
					label: '有效天数',
					prop: 'validDay',
					align: 'left',
					// width: '80'
				}, {
					label: '优惠券面额',
					prop: 'money',
					align: 'left',
					// width: '100'
				}, {
					columnType: 'fun',
					label: '优惠券类型',
					prop: 'couponsType',
					align: 'left',
					'show-overflow-tooltip': true,
					formatData: (e) => {
						let ele = this.couponsTypes.find(ele => ele.value == e)
						return ele ? ele.key : e
					}
				}, {
					label: '优惠券使用门槛',
					prop: 'doorSill',
					align: 'left',
					'show-overflow-tooltip': true
				}, {
					columnType: 'button',
					label: '操作',
					align: 'right',
					// fixed: 'right',
					buttons: [{
						type: 'text',
						text: '编辑',
						fn: this.editList
					}, {
						type: 'text',
						text: '删除',
						fn: this.deleteList,
					}, ],
				}, ],
				tableData: [],
				raffleRedsProp: {
					seriesId: '',
					propType: '',
					presellDate: '',
					propName: '',
					validDay: '',
					money: '',
					doorSill: '',
					couponsType: '',
					num: '',
					propImg: '',
					seriesId: '',
					seriesRaffleNum: '',
				}
			}
		},
		methods: {
			init(id) {
				this.isDrawer = true
				if (id) {
					this.goodId = id
					this.getTableData(id)
				}
				// this.getTableData()
			},
			//新增列表
			addList() {
				this.dialogTitle = "新增"
				let tableData = this.tableData
				const configMap = [{
						len: 0,
						name: '5元一番赏专用券*1',
						money: 5,
						seriesRaffleNum: 20
					},
					{
						len: 1,
						name: '10元一番赏专用券*1',
						money: 10,
						seriesRaffleNum: 60
					},
				]

				// 查找对应配置
				const len = tableData.length
				const config = configMap.find(item => item.len === len) || {
					name: '',
					money: '',
					seriesRaffleNum: 120
				}

				// 最终赋值（只写一次）
				this.raffleRedsProp = {
					seriesId: this.goodId,
					presellDate: '',
					propName: config.name,
					propType: config.name ? 4 : 1,
					propImg: config.name ? 'https://mtmanage.hzhxyqchy.com/ship_reward_logo.png' : '',
					propNum: 1,
					validDay: config.name ? 1 : '',
					money: config.money,
					doorSill: 0,
					couponsType: config.name ? 2 : '',
					seriesRaffleNum: config.seriesRaffleNum
				}
				this.dialogFormVisible = true
			},
			editList(row) {
				this.dialogTitle = "编辑"
				this.raffleRedsProp = JSON.parse(JSON.stringify(row))
				this.dialogFormVisible = true
			},
			deleteList(row) {
				this.$confirm('您确认删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(_ => {
					this.$http.post('/raffleRedsProp/removeRaffleRedsPropById', {
						id: row.id
					}).then(({
						data: result
					}) => {
						this.$message({
							message: '删除成功',
							type: 'success'
						})
						this.getTableData()
					})
				}).catch(_ => {})
			},
			//删除道具
			delProp(inx, rows) {
				rows.splice(inx, 1)
			},
			handPickerChange(value) {
				if (value && value.length != 0) {
					// this.retrieveForm.startDate = value[0]
					// this.retrieveForm.endDate = value[1]
					this.raffleRedsProp.presellDate = value
					console.log('presellDate', this.raffleRedsProp.presellDate)
				} else {
					this.raffleRedsProp.presellDate = ''
				}
			},
			//获取表格数据
			getTableData(id) {
				this.tabLoading = true
				this.$http.get('/raffleRedsProp/findRaffleRedsPropList', {
					params: {
						seriesId: this.goodId
					}
				}).then(({
					data: result
				}) => {
					this.tabLoading = false
					this.tableData = result.data
					// this.pageInfo.total = result.data.total
				}).catch(err => {
					this.tabLoading = false
				})
			},
			//确认弹框
			affirmPopup() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.butLoading = true
						let goodData = JSON.stringify(this.formActivity)
						let apiUrl = ""
						if (this.dialogTitle == '新增') {
							apiUrl = "/raffleRedsProp/addRaffleRedsProp"
						} else if (this.dialogTitle == '编辑') {
							apiUrl = "/raffleRedsProp/editRaffleRedsProp"
						}
						let raffleRedsProp = this.raffleRedsProp
						if (raffleRedsProp.propType != 4) {
							raffleRedsProp.money = ''
							raffleRedsProp.doorSill = ''
							raffleRedsProp.couponsType = ''
						}
						this.$http.post(apiUrl, raffleRedsProp).then(({
							data: result
						}) => {
							this.$message({
								message: this.dialogTitle + '成功',
								type: 'success'
							})
							this.butLoading = false
							this.getTableData()
							this.dialogFormVisible = false
						}).catch(err => {
							this.butLoading = false
						})
					}
				})
			},
			//重置清除校验
			resetForm() {
				Object.assign(this.$data.raffleRedsProp, this.$options.data().raffleRedsProp)
				this.$nextTick(() => {
					this.$refs.ruleForm.clearValidate()
				})
			},
			//关闭弹框
			handleClose() {
				this.isDrawer = false
			},
		}
	}
</script>
<style>
</style>